/**
 * Revokes the current Sanctum token on the server (best-effort).
 * Call before clearing partner_auth from localStorage.
 */
export async function revokePartnerTokenIfAny(axiosInstance) {
  try {
    const raw = localStorage.getItem('partner_auth');
    const p = raw ? JSON.parse(raw) : null;
    if (!p?.token || !axiosInstance?.post) return;
    await axiosInstance.post('/partner/logout');
  } catch {
    // ignore — session cleared locally anyway
  }
}
